import type { Transition } from "framer-motion";
import { varBounceOut } from "./bounceOut";

const TRANSITION_ENTER: Transition = { duration: 0.72, ease: [0.43, 0.13, 0.23, 0.96] };

export const varBounceIn = {
  animate: { scale: [0.3, 1.1, 0.9, 1.03, 0.97, 1], opacity: [0, 1, 1, 1, 1, 1], transition: TRANSITION_ENTER },
  exit: varBounceOut.animate,
};
